import { useSelector } from "react-redux";
import { GetAssetHistoryResponse, RootState } from "../package/rx.core";
import { useTriaUser } from "../package/ui.common/src/contexts/tria-user-provider/useTriaUser";
import { useTriaName } from "./useTriaName";

import { useQuery, UseQueryOptions } from "@tanstack/react-query";

export const useAssetHistory = (
  params?: Omit<
    UseQueryOptions<GetAssetHistoryResponse["data"]>,
    "queryKey" | "queryFn"
  >
) => {
  const { getAssetHistory } = useTriaUser();
  const { triaName } = useTriaName();
  const { chainName: chainNameState } = useSelector(
    (store: RootState) => store.Asset.fetchParam
  );
  const tokenAddress = useSelector(
    (store: RootState) => store.Asset.fetchParam.tokenAddress
  );

  const chainName = chainNameState || "POLYGON";

  const query = useQuery<GetAssetHistoryResponse["data"]>({
    queryKey: ["getAssetHistory", triaName, chainName, tokenAddress],
    queryFn: async () => {
      const resp = await getAssetHistory(chainName, tokenAddress, triaName);
      if (resp instanceof Error) {
        return Promise.reject(new Error(resp.message));
      }
      const { success, data, message } = resp;
      if (!success) {
        const messageError =
          data && "message" in data ? (data.message as string) : message;
        return Promise.reject(
          new Error(messageError, {
            cause: "handled",
          })
        );
      }
      if (data) {
        return data;
      }
      return Promise.reject(new Error(message));
    },
    retry: (count, error) => {
      return count < 3 && error.cause !== "handled";
    },
    staleTime: 5 * 10 * 1000,
    enabled: (params?.enabled ?? true) && !!triaName,
    ...params,
  });

  return query;
};
